<template>
  <el-dialog
    title=""
    :visible="innerVisible"
    append-to-body
    class="we-chat-auth-dialog"
    @close="handleClose"
  >
    <div>
      <h2>{{ $t('Tool.WeChatPushRemindTitle') }}</h2>
      <el-image
        :src="url"
        style="width: 150px"
      />
      <p>{{ $t('Message.Tips') }}</p>
      <p>{{ $t('Tool.WeChatPushRemind1') }}</p>
      <p>{{ $t('Tool.WeChatPushRemind2') }}</p>
    </div>
    <div slot="footer">
      <el-button type="primary" @click="change">{{ $t('Tool.IveFollowed') }}</el-button>
      <el-button plain @click="handleClose">{{ $t('Message.Cancel') }}</el-button>
    </div>
  </el-dialog>
</template>
<script>

import { queryQrCode } from '@/api/user'

export default {
  name: 'WeChatAuthDialog',
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    data: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      innerVisible: false,
      url: ''
    }
  },
  watch: {
    visible(newVal, oldVal) {
      this.innerVisible = newVal
    },
    innerVisible(newVal, oldVal) {
      this.$emit('update:visible', newVal)
    }
  },
  mounted() {
    this.initData()
  },
  methods: {
    async initData() {
      // queryQrCode().then(res => {
      //   if (res && res.data) {
      //     this.url = 'https://mp.weixin.qq.com/cgi-bin/showqrcode?ticket=' + res.data.ticket
      //   }
      // })
    },
    handleClose() {
      this.$emit('close')
    },
    change() {
      this.$emit('change', this.data)
    }
  }
}
</script>
<style lang="scss">
  @import "~@/styles/element-variables.scss";
.we-chat-auth-dialog{
  p{
    font-size: x-small;
    line-height: 0.4;
  }
}
</style>

